import { ProdutoServicoForm } from "../../../presentation/schemas/ProdutosServicos_lista/ProdutoServico";
import { ICreateProdutoServicoUseCase } from "../../../presentation/useCases/create/create_produto_servico_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * CreateProdutoServicoUseCase
 */

export class CreateProdutoServicoUseCase implements ICreateProdutoServicoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async createProdutoServico(form: ProdutoServicoForm): Promise<number> {
    return await this.repository.createProdutoServico(form);

  }
}
